// Arabic locale — primary language, hand-authored.
//
// `app` mirrors the en.ts keyset (Arabic has 6 CLDR plural forms, hence the
// extra `count_*` variants). No `legacy` bundle: Arabic is fast-pathed in the
// React shim (`t("ar","en")` returns the inline Arabic argument directly).

import type { LocaleBundle } from "../index";

const ar: LocaleBundle = {
  app: {
    common: {
      save: "حفظ",
      cancel: "إلغاء",
      delete: "حذف",
      edit: "تعديل",
      add: "إضافة",
      back: "رجوع",
      next: "التالي",
      loading: "جارٍ التحميل…",
      search: "بحث",
      language: "اللغة",
    },
    units: {
      count_zero: "لا وحدات",
      count_one: "وحدة واحدة",
      count_two: "وحدتان",
      count_few: "{{count}} وحدات",
      count_many: "{{count}} وحدة",
      count_other: "{{count}} وحدة",
    },
    error: {
      UNKNOWN: "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
      NETWORK: "خطأ في الشبكة. تحقق من اتصالك وأعد المحاولة.",
      UNAUTHORIZED: "ليست لديك صلاحية لتنفيذ هذا الإجراء.",
      VALIDATION: "بعض المعلومات المُدخلة غير صحيحة.",
      RATE_LIMITED: "محاولات كثيرة جدًا. يرجى الانتظار ثم المحاولة لاحقًا.",
      CONTRACT_OVERLAP: "يتداخل هذا العقد مع عقد قائم لنفس الوحدة.",
      AMOUNT_MISMATCH: "المبلغ لا يطابق القيمة المتوقعة.",
    },
  },
};

export default ar;
